"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Label_1 = require("../Label");
var hooks_1 = require("../../hooks");
exports.Radio = react_1.default.forwardRef(function (props, ref) {
    var checked = props.checked, className = props.className, disabled = props.disabled, error = props.error, id = props.id, label = props.label, labelProps = props.labelProps, name = props.name, onChange = props.onChange, onClick = props.onClick, readonly = props.readonly, size = props.size, value = props.value, onBlur = props.onBlur, onFocus = props.onFocus, rest = __rest(props, ["checked", "className", "disabled", "error", "id", "label", "labelProps", "name", "onChange", "onClick", "readonly", "size", "value", "onBlur", "onFocus"]);
    var newRef = react_1.default.useRef(null);
    var itemRef = ref ? ref : newRef;
    var isFocusVisible = hooks_1.useFocusVisible(itemRef).isFocusVisible;
    var onChangeHandler = function (e) {
        if (onChange) {
            onChange(value, e);
        }
    };
    var onClickHandler = function (e) {
        if (onClick) {
            onClick(e, props);
        }
    };
    var handleClickEvent = function (e) {
        var target = e.target;
        if (target.tagName !== 'INPUT') {
            e.stopPropagation();
        }
    };
    var getLabel = function () {
        if (label === undefined || label === '')
            return false;
        var labelClassName = (labelProps === null || labelProps === void 0 ? void 0 : labelProps.className) ? labelProps.className
            : null;
        var LabelClasses = classnames_1.default(labelClassName, 'Radio__label');
        return (react_1.default.createElement(Label_1.Label, __assign({ error: error, disabled: disabled }, labelProps, { className: LabelClasses }), label));
    };
    var RadioClasses = classnames_1.default('a-Radio', className, {
        'Radio--disabled': disabled || readonly,
        'Radio--checked': checked,
        'Radio--error': error,
        'Radio--fitted': label === undefined || label === '',
        'Radio--small': size === 'small',
        'Radio--large': size === 'large',
        'Radio--focus-visible': isFocusVisible,
    });
    return (react_1.default.createElement("div", __assign({ className: RadioClasses, onClick: handleClickEvent, ref: itemRef }, rest),
        react_1.default.createElement("label", { className: "Radio__html-label" },
            react_1.default.createElement("input", { checked: checked, className: "Radio__input", disabled: disabled, id: id, name: name, onChange: onChangeHandler, onClick: onClickHandler, role: "radio", type: "radio" }),
            react_1.default.createElement("span", { className: "Radio__box" }),
            getLabel())));
});
//# sourceMappingURL=Radio.js.map